import { Controller } from "stimulus";

export default class extends Controller {
  static values = { url: String }
  static targets = ["input", "feedback"]

  async validate() {
    const value = this.inputTarget.value.trim()
    this.clearFeedback()
    if (!value) return

    try {
      const response = await fetch(
        `${this.urlValue}?document=${encodeURIComponent(value)}`,
        {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
          }
        }
      )
      const data = await response.json()
      this.showFeedback(data)
    } catch (_e) {
      // silently ignore network errors — server validation will catch it on save
    }
  }

  showFeedback({ valid, error }) {
    if (valid) {
      this.inputTarget.classList.remove('is-invalid')
      this.inputTarget.classList.add('is-valid')
    } else {
      this.inputTarget.classList.remove('is-valid')
      this.inputTarget.classList.add('is-invalid')
      if (this.hasFeedbackTarget) this.feedbackTarget.textContent = error
    }
  }

  clearFeedback() {
    this.inputTarget.classList.remove('is-valid', 'is-invalid')
    if (this.hasFeedbackTarget) this.feedbackTarget.textContent = ''
  }
}
